<app-navigation [user]="user">
  <router-outlet></router-outlet>
</app-navigation>
